import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Transition from '@components/Transition';
import { TeleportToRoomDialogViewProps } from './interfaces';
import { useStyles } from './styles';

const TeleportToRoomDialogView = ({
  openTeleportToRoomDialog,
  currentRegion,
  handleKeepSharing,
  handleTeleportToRoom,
}: TeleportToRoomDialogViewProps) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog
      open={openTeleportToRoomDialog}
      TransitionComponent={Transition}
      keepMounted
      onBackdropClick={() => false}
      sx={classes.root}
    >
      <DialogTitle>{translate('sharingModal.teleportConfirm')}</DialogTitle>
      <DialogContentText>
        {translate('sharingModal.activeBroadcastStreams', { region: currentRegion?.region })}
      </DialogContentText>
      <DialogContent />
      <DialogActions>
        <Button onClick={handleKeepSharing}>{translate('close')}</Button>
        <Button onClick={handleTeleportToRoom}>{translate('actions.teleport')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TeleportToRoomDialogView;
